import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { TimeService } from './time.service';

export const Ng1TimeModule = angular
  .module('control-room.shared.services.time', [])
  .factory('crTimeService', downgradeInjectable(TimeService));
